function createEnum(definition) {
    const valueMap = {}
    const textMap = {}
    for (const enumName of Object.keys(definition)) {
        const [value, text] = definition[enumName]
        valueMap[enumName] = value
        textMap[value] = text
    }
    return {
        ...valueMap,
        getTextByName(name) {
            return (definition[name] && definition[name][1]) || ''
        },
    }
}

export default {
    // 全局错误码
    errorCode: createEnum({
        ErrUnauthenticated: [10002, '没有权限'],
    }),
    sexArr: ['女','男'],
    clans : ['汉', '蒙古', '回', '藏', '维吾尔', '苗', '彝', '壮', '布依', '朝鲜', '满', '侗', '瑶', '白', '土家', '哈尼', '哈萨克', '傣', '黎', '傈僳', '佤', '畲', '高山', '拉祜', '水', '东乡', '纳西', '景颇', '柯尔克孜', '土', '达斡尔', '仫佬', '羌', '布朗', '撒拉', '毛南', '仡佬', '锡伯', '阿昌', '普米', '塔吉克', '怒', '乌孜别克', '俄罗斯', '鄂温克', '德昂', '保安', '裕固', '京', '塔塔尔', '独龙', '鄂伦春', '赫哲', '门巴', '珞巴', '基诺', '阿美', '排灣', '泰雅', '布農', '卑南', '魯凱', '賽夏', '鄒', '達悟', '邵', '噶瑪蘭', '太魯閣', '撒奇萊雅', '賽德克', '拉阿魯哇', '卡那卡那富'],
    // 世代
    generations:[
        '一世','二世','三世','四世','五世','六世','七世','八世','九世','十世',
        '十一世','十二世','十三世','十四世','十五世','十六世','十七世','十八世','十九世','二十世',
        '二十一世','二十二世','二十三世','二十四世','二十五世','二十六世','二十七世','二十八世','二十九世','三十世',
        '三十一世','三十二世','三十三世','三十四世','三十五世','三十六世','三十七世','三十八世','三十九世','四十世',
        '四十一世','四十二世','四十三世','四十四世','四十五世','四十六世','四十七世','四十八世','四十九世','五十世','五十一世'
    ],
    // 字辈
    generationNames:[
        '无','无','无','无','无','无','无','无','无','无','无',
        '金','廷','鸣','佩','玉','芳','景','步','青','云',
        '龙','凤','呈','祥','瑞','邦','家','永','乐','新',
        '道','德','全','美','喜','言','行','进','成','真',
        '祖','工','传','元','圣','宗','业','庆','广','深'
],
    surnames: '赵钱孙李 周吴郑王 冯陈褚卫 蒋沈韩杨 朱秦尤许 何吕施张 孔曹严华 金魏陶姜\n' +
        '戚谢邹喻 柏水窦章 云苏潘葛 奚范彭郎 鲁韦昌马 苗凤花方 俞任袁柳 酆鲍史唐\n' +
        '费廉岑薛 雷贺倪汤 滕殷罗毕 郝邬安常 乐于时傅 皮卞齐康 伍余元卜 顾孟平黄\n' +
        '和穆萧尹 姚邵湛汪 祁毛禹狄 米贝明臧 计伏成戴 谈宋茅庞 熊纪舒屈 项祝董梁\n' +
        '杜阮蓝闵 席季麻强 贾路娄危 江童颜郭 梅盛林刁 钟徐邱骆 高夏蔡田 樊胡凌霍\n' +
        '虞万支柯 昝管卢莫 经房裘缪 干解应宗 丁宣贲邓 郁单杭洪 包诸左石 崔吉钮龚\n' +
        '程嵇邢滑 裴陆荣翁 荀羊於惠 甄曲家封 芮羿储靳 汲邴糜松 井段富巫 乌焦巴弓\n' +
        '牧隗山谷 车侯宓蓬 全郗班仰 秋仲伊宫 宁仇栾暴 甘钭厉戎 祖武符刘 景詹束龙\n' +
        '叶幸司韶 郜黎蓟薄 印宿白怀 蒲邰从鄂 索咸籍赖 卓蔺屠蒙 池乔阴郁 胥能苍双\n' +
        '闻莘党翟 谭贡劳逄 姬申扶堵 冉宰郦雍 却璩桑桂 濮牛寿通 边扈燕冀 郏浦尚农\n' +
        '温别庄晏 柴瞿阎充 慕连茹习 宦艾鱼容 向古易慎 戈廖庾终 暨居衡步 都耿满弘\n' +
        '匡国文寇 广禄阙东 欧殳沃利 蔚越夔隆 师巩厍聂 晁勾敖融 冷訾辛阚 那简饶空\n' +
        '曾毋沙乜 养鞠须丰 巢关蒯相 查后荆红 游竺权逯 盖益桓公 万俟司马 上官欧阳\n' +
        '夏侯诸葛 闻人东方 赫连皇甫 尉迟公羊 澹台公冶 宗政濮阳 淳于单于 太叔申屠\n' +
        '公孙仲孙 轩辕令狐 钟离宇文 长孙慕容 鲜于闾丘 司徒司空 亓官司寇 仉督子车\n' +
        '颛孙端木 巫马公西 漆雕乐正 壤驷公良 拓跋夹谷 宰父谷梁 晋楚闫法 汝鄢涂钦\n' +
        '段干百里 东郭南门 呼延归海 羊舌微生 岳帅缑亢 况后有琴 梁丘左丘 东门西门\n' +
        '商牟佘佴 伯赏南宫 墨哈谯笪 年爱阳佟 第五言福\n' +
        '趙錢孫 吳鄭 馮陳衛 韓楊 許 呂張 嚴華 \n' +
        '謝鄒 竇 雲蘇 範 魯韋馬 鳳 酆鮑\n' +
        '費 賀湯 羅畢 鄔 樂於時傅 齊 蔔 顧黃\n' +
        '蕭貝臧 計 談龐 紀 項\n' +
        '藍閔 強 賈婁 顏郭 鐘駱\n' +
        '虞萬 盧 經繆 幹應 賁鄧 單 諸 鈕龔\n' +
        '陸榮 儲 烏\n' +
        '車 宮 寧欒 鈄厲 劉 龍\n' +
        '葉韶 懷 從 鹹賴 藺 喬陰 蒼雙\n' +
        '聞黨 譚貢勞 酈 卻 壽 邊扈 郟農\n' +
        '溫別莊 瞿閻 連習 魚 慎 終 步 滿\n' +
        '國 廣祿闕東 歐 師鞏厙聶 訾闞 簡饒\n' +
        '養須豐 巢關 後紅 遊權 蓋 萬俟司馬 上官歐陽\n' +
        '夏侯諸葛 聞人東方 赫連皇甫 尉遲公羊 淡臺公冶 宗政濮陽 淳於單於 太叔申屠\n' +
        '公孫仲孫 軒轅令狐 鐘離宇文 長孫慕容 鮮於閭丘 司徒司空 亓官司寇 仉督子車\n' +
        '顓孫端木 巫馬公西 漆雕樂正 壤駟公良 拓跋夾谷 宰父谷梁 晉楚閆法 汝鄢塗欽\n' +
        '段幹百裏 東郭南門 呼延歸海 羊舌微生 嶽帥緱亢 況後有琴 梁丘左丘 東門西門\n' +
        '商牟佘佴 伯賞南宮 墨哈譙笪 年愛陽佟 第五言福',
    treeDemo: {
        
    }
}


